import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <h2>Alert Description</h2>
  <p>
      This alert(s) is generated every Sunday at 10:30 AM PST. It evaluates the prior week of stow data, identifies associates below the 250 PPH threshold who sit in the bottom 10% for that station, and surfaces alerts in the SCC Work-Items Tab. SLA: 6 days from generation. After completing the task, the same associate will not be re-flagged for 7 days, so AAs are not flagged in back-to-back weeks.
  </p>

  <h3><strong>4 Steps to Complete the SCC Work Items Alert</strong></h3>

  <p><strong>Step 1: Deliver the <em>AMZL NA Stow Mastery In-Session Training</em></strong></p>
  <ul>
      <li>
          <span className="wikiinternallink">
              <a href="https://iad.umbrella.amazon.dev/ata/initiate" rel="noopener noreferrer" target="_blank">ATA</a>
          </span>
          assign the <strong><em>AMZL NA Stow Mastery In-Session Training Guide</em></strong> in Umbrella to the identified associate.
      </li>
      <li>
          Open the Stow Mastery Tab on the
          <span className="wikiinternallink">
              <a href="https://us-east-1.quicksight.aws.amazon.com/sn/account/amzlbiaquicksight/dashboards/d33543bc-38f5-44db-be29-c6c278aaf61f?sso_login=true" rel="noopener noreferrer" target="_blank">
                  Vet Rate QuickSight Dashboard
              </a>
          </span>
          to identify which of the 7 UTRx stow metrics the associate is struggling with.
      </li>
      <li>Select 1-2 relevant topics based on the data and engage with the associate using the self-guided course.</li>
      <li>Complete the Umbrella course upon finishing the engagement.</li>
  </ul>

  <p><strong>Step 2: Assign the Learner Reaction Survey</strong></p>
  <ul>
      <li>
          Navigate to the
          <span className="wikiinternallink">
              <a href="https://iad.umbrella.amazon.dev/portal/enrollment/create/individual" rel="noopener noreferrer" target="_blank">Enrollment Tab</a>
          </span>
          in Umbrella and assign the <strong><em>AMZL NA Stow Mastery LRS</em></strong> (Learner Reaction Survey) to the associate.
      </li>
      <li>Guide the associate to select the training button, locate the LRS, and complete it before end of shift.</li>
  </ul>

  <p><strong>Step 3: Validate Completion</strong></p>
  <ul>
      <li>
          Use the
          <span className="wikiinternallink">
              <a href="https://iad.umbrella.amazon.dev/portal/transcript/learner" rel="noopener noreferrer" target="_blank">Transcripts Tab</a>
          </span>
          in Umbrella to verify:
          <ol>
              <li>The <strong><em>AMZL NA Stow Mastery – In-Session Training Guide</em></strong> was completed</li>
              <li>The <strong><em>AMZL NA Stow Mastery LRS</em></strong> was assigned</li>
          </ol>
      </li>
  </ul>

  <p><strong>Step 4: Close the SCC Work Item</strong></p>
  <ul>
      <li>Return to the SCC Work Item in the Work-Items Tab.</li>
      <li>Click the <strong>"Complete Task"</strong> button in the bottom right-hand corner.</li>
  </ul>

  <h3><strong>Program Guidance</strong></h3>

  <p><strong>Prepare Before You Engage</strong></p>
  <ul>
      <li>Ensure you use the <strong><em>Connection before Correction</em></strong> mindset for each associate engagement.</li>
      <li>Complete the <strong><em>AMZL NA Stow Mastery - Trainer Preparation</em></strong> course to revisit best practices or refresh your knowledge on the program.</li>
      <li>Limit the engagement to <strong>1-2 topics</strong> max - do not overload the associate.</li>
      <li>Keep the total engagement at <strong>30 minutes max</strong> and use the built-in observation time efficiently.</li>
      <li>If needed, assign assistance to the associate's stow aisles, during your engagement, using Ambassadors or PAs to keep aisles from getting overloaded.</li>
  </ul>

  <p><strong>Lead With Purpose</strong></p>
  <ul>
      <li>Lead your people and they will follow.</li>
      <li><strong>Why it matters: </strong>Drive associate process safety and standard work knowledge through collaborative engagement.</li>
      <li><strong>Root deliverables: </strong>Associate job safety, satisfaction, and performance.</li>
  </ul>

  <h3>Supplemental Links</h3>
  <p>Click any link below to open the resource.</p>
  <ol>
      <li>
          <span className="wikiinternallink">
              <a href="https://w.amazon.com/bin/view/AMZLCentralPrograms/AMZLLearningDev/Home/UTR/StowMastery/" rel="noopener noreferrer" target="_blank">
                  Stow Mastery Wiki
              </a>
          </span>
          – Program overview, program walkthrough video, pilot regions, trainer preparation resources, NoctOwl Chat Agent (Coming Soon) and key contacts.
      </li>
      <li>
          <span className="wikiinternallink">
              <a href="https://iad.prod.cms.umbrella.amazon.dev/course/80cd2510-b01d-54a4-ac5e-4269422ba43a" rel="noopener noreferrer" target="_blank">
                  AMZL NA Stow Mastery – In-Session Training Guide
              </a>
          </span>
          – Umbrella course for associates.
      </li>
      <li>
          <span className="wikiinternallink">
              <a href="https://iad.prod.cms.umbrella.amazon.dev/course/33153105-8365-5500-8e04-47eefe2b0204" rel="noopener noreferrer" target="_blank">
                  AMZL NA Stow Mastery – Trainer Preparation
              </a>
          </span>
          – Umbrella course for trainers.
      </li>
      <li>
          <span className="wikiinternallink">
              <a href="https://us-east-1.quicksight.aws.amazon.com/sn/account/amzlbiaquicksight/dashboards/d33543bc-38f5-44db-be29-c6c278aaf61f?sso_login=true" rel="noopener noreferrer" target="_blank">
                  Vet Rate Stow Mastery QuickSight Dashboard
              </a>
          </span>
          – Identify topics, prioritize additional associates, and track post-training PPH at 4 and 8 weeks (login: amzlbiaquicksight).
      </li>
      <li>
          <span className="wikiinternallink">
              <a href="https://us-east-1.quicksight.aws.amazon.com/sn/account/amzlbiaquicksight/dashboards/e5996fbe-2141-490a-adad-d5e8819be562/sheets/e5996fbe-2141-490a-adad-d5e8819be562_3e22dca5-bb8a-4f5b-bee3-f83b2c5c12af" rel="noopener noreferrer" target="_blank">
                  Manager Alerts QuickSight Dashboard
              </a>
          </span>
          – Stow Standard Work Tab. Track GCA completions; key columns: Course Completed?, Status, Success?, Pre Rate, Post Rate (login: amzlbiaquicksight).
      </li>
  </ol>

  <p style="font-size:22px"><u><strong>Did you perform the resolutions steps for Stow Mastery before closing out this alert?</strong></u></p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Stow_Standard_Work.jsx